"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var data_1 = require("../../data");
var view_simple_1 = __importDefault(require("../view-simple"));
var ui_1 = __importDefault(require("../form-simple/ui"));
var DetailSimple = function (_a) {
    var data = _a.data, fields = _a.fields, promise = _a.promise, message = _a.message, submitLabel = _a.submitLabel;
    return (react_1["default"].createElement(data_1.Detail, { data: data, promise: promise, FormUI: ui_1["default"](fields, undefined, submitLabel), ViewUI: function () { return react_1["default"].createElement(view_simple_1["default"], { data: data, fields: fields }); }, message: message }));
};
exports["default"] = DetailSimple;
